module.exports = "/fonts/vendor/iview/dist/styles/ionicons.woff?99ac3308dd8ee14f749f51538d0d5b9e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/iview/dist/styles/fonts/ionicons.woff?v=3.0.0
// module id = 97
// module chunks = 0